//Importación de librerias
//---------------PJ---------------
//Catalogos
import C001Area from '../../../src/components/PJ/Catalogos/001Area.vue'
import C002Materias from '../../../src/components/PJ/Catalogos/002Materia.vue'
import C004TipoDocumento from '../../../src/components/PJ/Catalogos/004TipoDocumento.vue'
import C006PuestoAdministrativo from '../../../src/components/PJ/Catalogos/006PuestoAdministrativo.vue'
import C008Delitos from '../../../src/components/PJ/Catalogos/008Delitos.vue'
import C009PartidosJudiciales from '../../../src/components/PJ/Catalogos/009PartidosJudiciales.vue'
import C010Municipios from '../../../src/components/PJ/Catalogos/010Municipios.vue'
import C011EntidadesFederativas from '../../../src/components/PJ/Catalogos/011EntidadesFederativas.vue'
import C012TiposSexo from '../../../src/components/PJ/Catalogos/012TiposSexo.vue'
import C013TiposDelitos from '../../../src/components/PJ/Catalogos/013TiposDelitos.vue'
import C015Despacho from '../../../src/components/PJ/Catalogos/015Despacho.vue'
import C017TipoDomicilio from '../../../src/components/PJ/Catalogos/017TipoDomicilio.vue'
import C019TipoTelefono from '../../../src/components/PJ/Catalogos/019TipoTelefono.vue'
import C020Salas from '../../../src/components/PJ/Catalogos/020Salas.vue'
import C021TipoDespacho from '../../../src/components/PJ/Catalogos/021TipoDespacho.vue'
import C022DependenciaPublica from '../../../src/components/PJ/Catalogos/022DependenciaPublica.vue'
import C024TipoAudiencia from '../../../src/components/PJ/Catalogos/024TipoAudiencia.vue'
import C027TiposTitulo from '../../../src/components/PJ/Catalogos/027TiposTitulo.vue'
import C029TipoPersonalidad from '../../../src/components/PJ/Catalogos/029TipoPersonalidad.vue'
import C031Sistemas from '../../../src/components/PJ/Catalogos/031Sistemas.vue'
import C034TipoEvidencia from '../../../src/components/PJ/Catalogos/034TipoEvidencia.vue'
import C036FundamentosLegales from '../../../src/components/PJ/Catalogos/036FundamentosLegalesBuscador.vue'
import C037Paises from '../../../src/components/PJ/Catalogos/037Paises.vue'
import C038TiposIdentificacion from '../../../src/components/PJ/Catalogos/038TiposIdentificacion.vue'
import C039TipoDepartamento from '../../../src/components/PJ/Catalogos/039TiposDepartamento.vue'
import C041TiposEstadosCiviles from '../../../src/components/PJ/Catalogos/041TiposEstadosCiviles.vue'
import C042Juicios from '../../../src/components/PJ/Catalogos/042Juicios.vue'
import C042JuiciosTemisCivil from '../../../src/components/PJ/Catalogos/042JuiciosTemisCivil.vue'
import C046Tramites from '../../../src/components/PJ/Catalogos/046Tramites.vue'
import C046TramitesTemisCivil from '../../../src/components/PJ/Catalogos/046TramitesTemisCivil.vue'
import C044TiposPuestos from '../../../src/components/PJ/Catalogos/044TiposPuestos.vue'
import C045Puestos from '../../../src/components/PJ/Catalogos/045Puestos.vue'
import C045PuestosBuscador from '../../../src/components/PJ/Catalogos/045PuestosBuscador.vue'
import C048TiposFirmaElectronica from '../../../src/components/PJ/Catalogos/048TiposFirmaElectronica.vue'
import C051Anexos from '../../../src/components/PJ/Catalogos/051Anexos.vue'
import C052NivelesPuestos from '../../../src/components/PJ/Catalogos/052NivelesPuestos.vue'
import C060TiposCategoriasPuestos from '../../../src/components/PJ/Catalogos/060TiposCategoriasPuestos.vue'

//Creamos y asignamos los datos necesarios de PJ
const pj = [
  { Proviene: 'PJ', Nombre: 'C001Area', datos: C001Area },
  { Proviene: 'PJ', Nombre: 'C002Materias', datos: C002Materias },
  { Proviene: 'PJ', Nombre: 'C004TipoDocumento', datos: C004TipoDocumento },
  { Proviene: 'PJ', Nombre: 'C006PuestoAdministrativo', datos: C006PuestoAdministrativo },
  { Proviene: 'PJ', Nombre: 'C008Delitos', datos: C008Delitos },
  { Proviene: 'PJ', Nombre: 'C009PartidosJudiciales', datos: C009PartidosJudiciales },
  { Proviene: 'PJ', Nombre: 'C010Municipios', datos: C010Municipios },
  { Proviene: 'PJ', Nombre: 'C011EntidadesFederativas', datos: C011EntidadesFederativas },
  { Proviene: 'PJ', Nombre: 'C012TiposSexo', datos: C012TiposSexo },
  { Proviene: 'PJ', Nombre: 'C013TiposDelitos', datos: C013TiposDelitos },
  { Proviene: 'PJ', Nombre: 'C015Despacho', datos: C015Despacho },
  { Proviene: 'PJ', Nombre: 'C017TipoDomicilio', datos: C017TipoDomicilio },
  { Proviene: 'PJ', Nombre: 'C019TipoTelefono', datos: C019TipoTelefono },
  { Proviene: 'PJ', Nombre: 'C020Salas', datos: C020Salas },
  { Proviene: 'PJ', Nombre: 'C021TipoDespacho', datos: C021TipoDespacho },
  { Proviene: 'PJ', Nombre: 'C022DependenciaPublica', datos: C022DependenciaPublica },
  { Proviene: 'PJ', Nombre: 'C024TipoAudiencia', datos: C024TipoAudiencia },
  { Proviene: 'PJ', Nombre: 'C027TiposTitulo', datos: C027TiposTitulo },
  { Proviene: 'PJ', Nombre: 'C029TipoPersonalidad', datos: C029TipoPersonalidad },
  { Proviene: 'PJ', Nombre: 'C031Sistemas', datos: C031Sistemas },
  { Proviene: 'PJ', Nombre: 'C034TipoEvidencia', datos: C034TipoEvidencia },
  { Proviene: 'PJ', Nombre: 'C036FundamentosLegales', datos: C036FundamentosLegales },
  { Proviene: 'PJ', Nombre: 'C037Paises', datos: C037Paises },
  { Proviene: 'PJ', Nombre: 'C038TiposIdentificacion', datos: C038TiposIdentificacion },
  { Proviene: 'PJ', Nombre: 'C039TipoDepartamento', datos: C039TipoDepartamento },
  { Proviene: 'PJ', Nombre: 'C041TiposEstadosCiviles', datos: C041TiposEstadosCiviles },
  { Proviene: 'PJ', Nombre: 'C042JuiciosTemisCivil', datos: C042JuiciosTemisCivil },
  { Proviene: 'PJ', Nombre: 'C042Juicios', datos: C042Juicios },
  { Proviene: 'PJ', Nombre: 'C046Tramites', datos: C046Tramites },
  { Proviene: 'PJ', Nombre: 'C046TramitesTemisCivil', datos: C046TramitesTemisCivil },
  { Proviene: 'PJ', Nombre: 'C044TiposPuestos', datos: C044TiposPuestos },
  { Proviene: 'PJ', Nombre: 'C045Puestos', datos: C045Puestos },
  { Proviene: 'PJ', Nombre: 'C045PuestosBuscador', datos: C045PuestosBuscador },
  { Proviene: 'PJ', Nombre: 'C048TiposFirmaElectronica', datos: C048TiposFirmaElectronica },
  { Proviene: 'PJ', Nombre: 'C051Anexos', datos: C051Anexos },
  { Proviene: 'PJ', Nombre: 'C052NivelesPuestos', datos: C052NivelesPuestos },
  { Proviene: 'PJ', Nombre: 'C060TiposCategoriasPuestos', datos: C060TiposCategoriasPuestos },
]

//Exportamos los datos de PJ
export default pj;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/pj.js
// module id = null
// module chunks = 